import { render, staticRenderFns } from "./MoleculeContentNodeBlockImage.vue?vue&type=template&id=74e7bb90&"
import script from "./MoleculeContentNodeBlockImage.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentNodeBlockImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports